var map = {
	"./admin.ts": 81,
	"./attach.ts": 149,
	"./config.ts": 121,
	"./dashboard.ts": 491,
	"./declare.ts": 150,
	"./edu.ts": 54,
	"./edumain.ts": 117,
	"./exam.ts": 38,
	"./form.ts": 180,
	"./license.ts": 170,
	"./log.ts": 210,
	"./login.ts": 96,
	"./phishing.ts": 122,
	"./quiz.ts": 198,
	"./register.ts": 192,
	"./share.ts": 196,
	"./startExam.ts": 108,
	"./tag.ts": 111,
	"./target.ts": 76,
	"./template.ts": 87,
	"./user.ts": 75
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1296;